import { prefix } from '@root/utils/Lang';

const modulePrefix = 'module.bannerPlace';

const translations = {
    'bannerPlace': 'Bannerhelyek',
    'id.title': 'ID',
    'create.title': 'Bannerhely létrehozása',
    'edit.title': 'Bannerhely szerkesztése',
    'name.title': 'Név',
    'type_id.title': 'Bannerhely típusa',
};

export default prefix(modulePrefix, translations);



// WEBPACK FOOTER //
// ./src/modules/BannerPlace/lang/hu.ts